import React from 'react';
import styled from 'styled-components';

// Edge to edge: an embed built to fill (width and height 100%, as Studio
// builds them) fills the card, and a fixed-size one is kept within it
const Frame = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  iframe {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
`;

const IFrameGadget = ({ snippet }: { snippet: string }) => (
  <Frame dangerouslySetInnerHTML={{ __html: snippet }} />
);

export default IFrameGadget;
